import React from 'react'
import { generatePath, useNavigate as useRouterNavigate } from 'react-router'

export const useNavigate = () => {
  const navigate = useRouterNavigate()
  return React.useCallback((route: string, params?: TObjectAny) => navigate(generatePath(route, params)), [])
}
